import { render, staticRenderFns } from "./MarketingAutomationFormStepsAdd.vue?vue&type=template&id=5408208c&scoped=true"
import script from "./MarketingAutomationFormStepsAdd.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationFormStepsAdd.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationFormStepsAdd.vue?vue&type=style&index=0&id=5408208c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408208c",
  null
  
)

export default component.exports